import { RegisterForm } from '@shared/features/auth/components/RegisterForm';

export default function RegisterPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="flex justify-center">
        <RegisterForm />
      </div>
    </div>
  );
}